import { AfterViewInit, Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { ManageType } from 'src/app/decorators/type-manager-decorator';
import { ContactContainer } from 'src/app/interfaces/contact-container';
import { CNConsultation } from 'src/app/models/cnconsultation';

@ManageType('ContactContentSimpleComponent')
@Component({
  selector: 'app-contact-content-simple',
  templateUrl: './contact-content-simple.component.html',
  styleUrls: ['./contact-content-simple.component.scss']
})
export class ContactContentSimpleComponent implements OnInit, ContactContainer {

  private contentContact: CNConsultation;

  constructor() {
  }

  ngOnInit(): void {
  }

  /**
   * ContactContainer interface
   */

  @Input() set contact(theContact: CNConsultation) {
    this.contentContact = theContact;
    console.log('contact', this.contentContact);
  }

  get contact(): CNConsultation {
    return this.contentContact;
  }
}
